export default "__VITE_ASSET__9e2f108d__"